import type { Song } from './types';
import { Stack } from 'styled-system/jsx';
import { Link } from '~/components/ui/link';
import { Table } from '~/components/ui/table';
import { Text } from '~/components/ui/text';

type Props = {
  song: Song;
  title: string;
  secondaryTitle?: string;
  mobileMeta?: {
    description: string;
    duration: string;
  };
};

export function SongTitleCell({ song, title, secondaryTitle, mobileMeta }: Props) {
  return (
    <Table.Cell>
      <Stack gap="0.5">
        <Link href={`/${song.id}`} fontWeight="bold">
          {title}
        </Link>
        {secondaryTitle ? (
          <Text hideBelow="md" color="fg.muted">
            {secondaryTitle}
          </Text>
        ) : null}
        {mobileMeta ? (
          <Text hideFrom="md" color="fg.muted" lineHeight="1.3" whiteSpace="normal">
            {mobileMeta.duration} | {mobileMeta.description}
          </Text>
        ) : null}
      </Stack>
    </Table.Cell>
  );
}
